
// Running against a local API (Aspire / dotnet run) rather than a deployed environment.
export const isLocalDevelopment = window.location.hostname === "localhost";

export const apiUrl =
  window.location.hostname.indexOf(".sharepark.net") > -1
    ? window.location.hostname.replace("admin", "api")
    : "localhost:5001";